'use strict';

const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/productImageGallery'));
    processInclude(require('./product/stickyBuyBar'));
    processInclude(require('./components/stores'));
    processInclude(require('./components/appointment'));
    processInclude(require('./components/loadVideos'));
    processInclude(require('./components/carouselPreviewImages'));
    processInclude(require('./components/productDetailQuickView'));
    processInclude(require('./components/productAttributeSections'));
    processInclude(require('./product/wishlist'));
});
